import React from 'react'
import './Whyus.css'
const WhyUs = () => {
  return (
    <section className="section-box box-why-choose-us background-body">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6 mb-40">
          <span className="btn btn-tag">Why Choose Yatri Service?</span>
          <h2 className="title-why neutral-1000">
          Elevate Your Business Travel Experience
          </h2>
          <p className="text-xl-medium neutral-500">
          Take your travel agency to new heights with Yatri Service. Sign up now and experience the ease and efficiency of our B2B travel portal. Elevate your business, exceed your clients' expectations, and embrace a future of limitless possibilities in the world of travel.
          </p>
          
        </div>
        <div className="col-lg-6 mb-40">
          <div className="row">
            <div className="col-sm-6 mt-35">
              <div className="card-why-choose-us">
                <div className="card-image">
                  {" "}
                  <img
                    src="https://travila-nextjs.vercel.app/assets/imgs/page/homepage1/destination.png"
                    alt="Travila"
                  />
                </div>
                <div className="card-info">
                  <h6 className="text-xl-bold" style={{color:'#fff'}}>4500+ Destination</h6>
                  <p className="text-sm-medium neutral-400" style={{color:'#000'}}>
                    Our expert team handpicked all destinations in this site.
                  </p>
                </div>
              </div>
              <div className="card-why-choose-us card-why-choose-us-type-2">
                <div className="card-info">
                  <h6 className="text-xl-bold">Fast Booking</h6>
                  <p className="text-sm-medium neutral-400">Secure payment</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="card-why-choose-us background-body">
                <div className="card-image">
                  {" "}
                  <img
                    src="https://travila-nextjs.vercel.app/assets/imgs/page/homepage1/support.png"
                    alt="Travila"
                  />
                </div>
                <div className="card-info">
                  <h6 className="text-xl-bold neutral-1000">
                    Great 24/7 Support
                  </h6>
                  <p className="text-sm-medium neutral-400">
                    We are here to help, before, during, and even after your trip.
                  </p>
                </div>
              </div>
              <div className="card-why-choose-us card-why-choose-us-type-3">
                <div className="card-info">
                  <h6 className="text-xl-bold" style={{color:'#fff'}}>Best Price</h6>
                  <p className="text-sm-medium neutral-400" style={{color:'#000'}}>
                    Price match within 48 hours of order confirmation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default WhyUs